import DeleteIcon from '@mui/icons-material/Delete';
import { Box, BoxProps } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { memo, useState } from 'react';
import MediaActionButton from '../../components/MediaActionButton';
import TeceoDragHandle from '../../components/TeceoDraghandle';
import useMediaStyles from '../../components/useMediaStyles';
import { IMedia, getMediaCover } from '../../lib/MediasLib';
import { MediaPreview } from './MediaPreview';
import MediaRenderer from './MediaRenderer';

export type MediaCardOptions = {
  showRemoveMediaButton?: boolean;
  mediaContentContain?: boolean;
  disableDrag?: boolean;
  inModal: boolean;
};

export type MediaCardProps = {
  media: IMedia;
  onRemoveClick: (media: IMedia) => void;
  options?: MediaCardOptions;
  dragHandleProps?: BoxProps;
};

const MediaCard = ({ media, onRemoveClick, options, dragHandleProps }: MediaCardProps) => {
  const { classes: mediaClasses } = useMediaStyles({});
  const [preview, setPreview] = useState<boolean>(false);

  const mediaUrl = getMediaCover(media);
  return (
    <>
      <Card className={mediaClasses.root}>
        <CardMedia onClick={() => setPreview(true)}>
          <MediaRenderer
            src={mediaUrl}
            type={media?.type}
            mediaContentContain={options?.mediaContentContain}
          />
        </CardMedia>

        {options?.showRemoveMediaButton && (
          <Box
            className={mediaClasses.mediaControlsTop}
            sx={{ right: (theme) => theme.spacing(1) }}
          >
            <MediaActionButton onClick={() => onRemoveClick(media)}>
              <DeleteIcon />
            </MediaActionButton>
            {!options.disableDrag && (
              <Box {...dragHandleProps}>
                <TeceoDragHandle />
              </Box>
            )}
          </Box>
        )}
      </Card>
      <MediaPreview
        media={media}
        show={preview}
        onClose={() => setPreview(false)}
        mediaContentContain={options?.mediaContentContain}
      />
    </>
  );
};

export default memo(MediaCard);
